module.exports = __webpack_public_path__ + "img/accordion.9c2e1e85.png";